module.exports = __webpack_public_path__ + "img/micro.87c8a7a1.svg";